import classNames from 'classnames';
import React from 'react';

import loginIllustrationSrc from 'assets/login-illustration.png';
import css from './BlueLayout.module.css';

export const LoginLikeLayout = () => (
  <div
    className={classNames(css.headlineContainer, css.signInHeadlineContainer)}
  >
    <div>
      <div className={css.headline}>
        <span>Every website visitor is a potential customer</span>

        <span className={css.subtitle}>
          Get your website visitor data back on track
        </span>
      </div>
      <img src={loginIllustrationSrc} className={css.loginImage} />
    </div>
  </div>
);
